export const constants = {
  supportMail: "support@octrace.ai",
};
